<template>
  <div class="stock">
    <van-notice-bar wrapable :scrollable="false" text="请核对信息，若有误请点击进行修改" />
    <ScanQR @scan="onScan" @input="onInput" :value="assetObj.serial" />

    <transition name="van-fade">
      <van-cell-group v-show="assetDetail" class="stock-assetDetail" :border="false">
        <!--          <van-cell :title="$t('message.dept')" :value="assetObj.dept" :border="false"/>
          <van-cell :title="$t('message.heldby')" :value="assetObj.heldby" :border="false"/>
          <van-cell :title="$t('message.location')" :value="assetObj.location" :border="false" />   -->
        <!--           <van-cell title="dept" :value="assetObj.dept" :border="false"/>
          <van-cell title="city" :value="assetObj.city" :border="false"/>
          <van-cell title="location" :value="assetObj.storage_location" :border="false" />
          <van-cell title="English Name" :value="assetObj.heldby_name" :border="false" />
          <van-cell title="status" :value="assetObj.status" :border="false" /> -->
        <van-field label="资产编号" v-model="assetObj.asset_num" disabled />
        <van-field label="Status" v-model="assetObj.status_bz" disabled />
        <van-field v-model="assetObj.bu" label="BU" />
        <van-field v-model="assetObj.dept" label="部门" />
        <van-field v-model="assetObj.chinese_name" label="使用人" />
        <van-field v-model="assetObj.city" label="城市" />
        <van-field v-model="assetObj.heldby" label="联系电话" />
      </van-cell-group>
    </transition>

    <van-divider content-position="left">{{ $t('message.photoTip1') }}</van-divider>

    <!-- <ChooseImg class="stock-img" @finish="photo1" ref="chooseImg1" /> -->
    <ChooseImgs class="stock-img" @finish="photo1" ref="chooseImg1" :stockType="stockType" />

    <!-- <van-divider content-position="left">{{$t('message.photoTip2')}}</van-divider>

    <ChooseImg class="stock-img" @finish="photo2" ref="chooseImg2" /> -->

    <van-switch-cell v-model="question" :title="$t('message.question')" />


    <van-field v-model="remark" clearable :placeholder="$t('message.remarksTip')" :label="$t('message.remarks')"
      type="textarea" maxlength="200" autosize show-word-limit />

    <div class="stock-submit">
      <van-button round type="primary" :loading="submitting" :loading-text="$t('message.submitTip')" @click="onSubmit">
        {{ $t('message.submit') }} </van-button>
    </div>

  </div>
</template>

<script>
import {
  Button,
  Image,
  Field,
  Icon,
  Cell,
  CellGroup,
  Divider,
  SwitchCell,
  Toast,
  Dialog,
  NoticeBar
} from 'vant';
import { jsConfig } from '@/api/wx';
// import ChooseImg from '@/components/chooseImg';
import ChooseImgs from '@/components/chooseImgs';
import ScanQR from '@/components/scanQR';
export default {
  components: {
    ScanQR,
    ChooseImgs,
    [Button.name]: Button,
    [Image.name]: Image,
    [Field.name]: Field,
    [Icon.name]: Icon,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Divider.name]: Divider,
    [SwitchCell.name]: SwitchCell,
    Toast,
    Dialog,
    [NoticeBar.name]: NoticeBar
  },

  data() {
    return {
      assetOld: {},
      assetObj: {
        picture: []
      },
      assetNum: '',
      assetDetail: {},
      question: '',
      remark: '',
      loading: false,
      img1: '',
      img2: '',
      stockType: '',
      address: '',
      submitting: false
    };
  },

  methods: {
    onScan(val) {
      this.stockType = 'qrcode';
      this.getAsset('qrcode', val)
    },
    onInput(val) {
      this.stockType = 'input';
      this.getAsset('serial', val)
    },
    getAsset(type, value) {
      this.$refs.chooseImg1.refresh()
      this.$axios.get('asset/query?type=' + type + '&value=' + encodeURIComponent(value)).then(res => {
        if (res.stock_status == '已盘点') {
          Toast('该资产已盘点完成');
        }
        this.assetObj = res
        this.assetOld = {
          bu: res.bu,
          dept: res.dept,
          heldby: res.heldby,
          chinese_name: res.chinese_name,
          city: res.city,
          picture: res.picture
        }
        if(!res.picture) {
          this.assetOld.picture = []
          this.assetObj.picture = []
        }
      })
    },
    photo1(id) {
      // this.img1 = id; //上传一张照片
      // 上传多张照片
      this.assetObj.picture.push(id);
      console.log('上传的图片路径', this.assetObj.picture)
    },
    photo2(id) {
      this.img2 = id;
    },
    onSubmit() {
      if (!this.assetObj.id) {
        Toast('请输入需要盘点的资产');
        return;
      }
      if (this.question && !this.remark) {
        Toast('有疑问时，请输入备注');
        return;
      }
      let changeFields = Object.keys(this.assetOld).filter(item => {
        return this.assetOld[item] != this.assetObj[item]
      })
      const stock_question = (this.question || changeFields.length > 0 || this.remark) ? '1' : '0'

      //if (!this.img1 || !this.img2) {
      //  Toast('请按提示拍摄资产图片');
      //  return;
      //}
      
      
      if (this.stockType =='list' && this.assetObj.picture.length==0 ) {
        Toast('请按提示上传资产图片');
        return;
      }
      this.submitting = true;
      this.assetObj.picture = JSON.stringify(this.assetObj.picture);
      this.$axios.post('asset/stock', {
        id: this.assetObj.id,
        stock_type: this.stockType,
        stock_pictures: this.img1,
        stock_question,
        change_field: changeFields.join(','),
        stock_comments: this.remark,
        stock_location: this.address,
        city: this.assetObj.city,
        bu: this.assetObj.bu,
        dept: this.assetObj.dept,
        heldby: this.assetObj.heldby,
        chinese_name: this.assetObj.chinese_name,
        picture: this.assetObj.picture
      }).then((number) => {
        const message = '当前资产已完成盘点，盘点信息可以在"盘点记录"查看；\n' + (number > 0 ? `您当前还有${number}个资产未盘点，请继续` : '');
        Dialog({
          title: '提交成功',
          message
        })
        this.submitting = false;
        this.assetObj = {},
          this.assetNum = '',
          this.assetDetail = {},
          this.question = '',
          this.remark = '',
          this.loading = false,
          this.img1 = '',
          this.img2 = '',
          this.stockType = ''
        this.assetObj.picture = []
        this.$refs.chooseImg1.refresh()
      }).catch(res => {
        Dialog({ message: '盘点失败\n' + res })
        this.submitting = false;
      })
    }
  },

  created() {
    let { id } = this.$route.query;
    if (id) {
      this.$nextTick(() => {
        this.stockType = "list";
        this.getAsset('id', id);
      })
    }
    this.$wx.ready(() => {
      this.$wx.getLocation({
        type: "wgs84", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入"gcj02"
        success: (res) => {
          this.$axios.get('wx/location?lat=' + res.latitude + '&lng=' + res.longitude)
            .then(addr => {
              Toast(addr ? '定位：' + addr : '定位异常');
              this.address = addr;
            })
          /*
           var pt = new BMap.Point(res.longitude, res.latitude);
           var geoc = new BMap.Geocoder();

           console.log(pt, geoc)
           geoc.getLocation(pt, function(rs){

             var addComp = rs.surroundingPois;
             if(addComp.length>0){
               console.log(addComp[0].title);
               address = addComp[0].title;
             } else {
               console.log("address:" + rs.address);
               address = rs.address;
             }

           });*/

        },
        fail() {
          Toast('定位失败');
        }
      });
    });
    jsConfig();
  }
};
</script>

<style lang="less">
.stock {
  padding: 20px 0 50px 0;

  &-assetDetail {
    padding: 10px 20px;
  }

  &-img {
    margin-left: 20px;
  }

  &-submit {
    text-align: center;

    button {
      padding: 0 50px;
      margin: 20px auto;
    }
  }

}
</style>
